const oneSecondMills = 1e3;

const createTimer = (duration: number, onTick: (seconds: number) => void, onTimeOut: () => void) => {
  const startTime = Date.now();

  const interval = setInterval(() => {
    const currentTime = Date.now();

    if (startTime + duration * oneSecondMills <= currentTime) {
      onTimeOut();
      clearInterval(interval);

      return;
    }

    const secondsElapsed = Math.floor((currentTime - startTime) / oneSecondMills);

    onTick(duration - secondsElapsed);
  }, oneSecondMills);

  return {
    clearTimer: () => {
      clearInterval(interval);
    },
  };
};

export { createTimer };
